module.exports = __webpack_public_path__ + "img/about-ch2-urbanproblems-inclusivity.f0e693c5.svg";